var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoWikiWhite = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "74px",
    height: "74px",
    viewBox: "0 0 74 74",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ico_wiki") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_wiki",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(15.000000, 12.000000)",
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.479,47.6021 C2.78,47.6021 2.082,47.2641 2.082,45.9561 C2.082,45.8771 2.097,45.8391 2.152,45.7871 C2.339,45.6051 2.877,45.3231 4.479,45.2981 L4.479,45.3101 L40.061,45.3101 L40.061,47.6021 L5.479,47.6021 Z M4.479,2.4091 L4.479,43.2981 C3.665,43.3071 2.821,43.3831 2.082,43.6161 L2.082,3.0441 C2.082,2.5651 3.388,2.4411 4.479,2.4091 L4.479,2.4091 Z M6.479,43.3101 L40.061,43.3101 L40.061,2.3981 L6.479,2.3981 L6.479,43.3101 Z M6.479,0.3981 L5.479,0.3981 C3.46,0.3981 0.082,0.3981 0.082,3.0441 L0.082,45.9561 C0.082,49.6021 3.727,49.6021 5.479,49.6021 L42.061,49.6021 L42.061,0.3981 L6.479,0.3981 Z",
    id: "Fill-3"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4",
    points: "16.3911 31.4951 20.2641 31.4951 23.2371 18.5131 26.3191 31.4951 30.1921 31.4951 34.0101 13.3851 30.6281 13.3851 27.9551 28.0041 24.7371 13.3851 21.7911 13.3851 18.5741 28.0041 15.8461 13.3851 12.4631 13.3851"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoWikiWhite);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_wiki_white.e6a5d550d71fc2b03142358883efb4a3.svg";